import { useEffect, useState } from 'react';
import api from '../services/api';

const ESTATUS_COLORS: Record<string, string> = {
  Pendiente: 'bg-yellow-100 text-yellow-700',
  Cotizado:  'bg-blue-100 text-blue-700',
  Renovada:  'bg-green-100 text-green-700',
  Perdida:   'bg-red-100 text-red-700',
};

const diasRestantes = (fecha: string) => {
  const diff = new Date(fecha).getTime() - new Date().getTime();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

export default function Renovaciones() {
  const [renovaciones, setRenovaciones] = useState<any[]>([]);
  const [tab, setTab] = useState<'Pendiente' | 'Cotizado' | 'Renovada' | 'Perdida'>('Pendiente');

  const fetchData = () =>
    api.get(`/renovaciones?estatus=${tab}`).then(r => setRenovaciones(r.data));

  useEffect(() => { fetchData(); }, [tab]);

  const handleEstatus = async (id: number, estatus: string) => {
    await api.patch(`/renovaciones/${id}/estatus`, { estatus });
    fetchData();
  };

  const handleGenerar = async () => {
    await api.post('/renovaciones/generar');
    fetchData();
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Renovaciones</h2>
          <p className="text-sm text-gray-500 mt-0.5">Pólizas próximas a vencer</p>
        </div>
        <button onClick={handleGenerar}
          className="bg-primary-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-primary-700">
          ⚡ Generar pendientes
        </button>
      </div>

      <div className="flex gap-2 mb-4">
        {(['Pendiente', 'Cotizado', 'Renovada', 'Perdida'] as const).map(t => (
          <button key={t} onClick={() => setTab(t)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
              tab === t ? 'bg-primary-600 text-white' : 'bg-white text-gray-600 border'
            }`}>
            {t}
          </button>
        ))}
      </div>

      <div className="space-y-3">
        {renovaciones.map(r => {
          const dias = diasRestantes(r.fechaVencimiento);
          return (
            <div key={r.id} className={`bg-white rounded-xl shadow-sm p-4 border-l-4 ${
              dias <= 7 ? 'border-red-400' : dias <= 30 ? 'border-yellow-400' : 'border-green-400'
            }`}>
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-medium text-gray-800">{r.poliza?.cliente?.nombre}</p>
                  <p className="text-sm text-gray-500">
                    {r.poliza?.ramo} · {r.poliza?.aseguradora} · Póliza {r.poliza?.numeroPoliza}
                  </p>
                  <p className="text-sm text-gray-500 mt-0.5">
                    Prima actual: <span className="font-medium">${r.poliza?.prima?.toLocaleString()}</span>
                  </p>
                  {r.nuevaPrima && (
                    <p className="text-sm text-gray-500">
                      Nueva prima: <span className="font-medium text-green-600">${r.nuevaPrima.toLocaleString()}</span>
                      {r.nuevaAseguradora && ` · ${r.nuevaAseguradora}`}
                    </p>
                  )}
                </div>
                <div className="text-right">
                  <p className={`text-sm font-bold ${
                    dias <= 7 ? 'text-red-500' : dias <= 30 ? 'text-yellow-600' : 'text-green-600'
                  }`}>
                    {dias <= 0 ? 'Vencida' : `${dias} días`}
                  </p>
                  <p className="text-xs text-gray-400">
                    {new Date(r.fechaVencimiento).toLocaleDateString('es-MX')}
                  </p>
                  <select value={r.estatus} onChange={e => handleEstatus(r.id, e.target.value)}
                    className={`mt-2 text-xs px-2 py-1 rounded-full border-0 font-medium ${ESTATUS_COLORS[r.estatus]}`}>
                    {Object.keys(ESTATUS_COLORS).map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
              </div>
              {r.notas && <p className="text-xs text-gray-400 mt-2">{r.notas}</p>}
              <p className="text-xs text-gray-400 mt-1">Agente: {r.agente?.nombre}</p>
            </div>
          );
        })}

        {renovaciones.length === 0 && (
          <div className="bg-white rounded-xl p-8 text-center text-gray-400">
            No hay renovaciones en estado "{tab}"
          </div>
        )}
      </div>
    </div>
  );
}
